import { APP_NAME } from "@constants/app.constants";
import InventoryItemListComponent from "@screens/inventory/inventory-items/inventory-item-list/item-list.component";
import InventoryItemsCreateComponent from "@screens/inventory/inventory-items/inventory-item-create/item-create.component";
import InventoryItemsEditComponent from "@screens/inventory/inventory-items/inventory-item-edit/item-edit.component";
import InventoryItemsFileUploadComponent from "@screens/inventory/inventory-items/inventory-item-upload/item-file-upload.component";

const inventoryItemsRoutes = [
  {
    name: `Inventory Items - ${APP_NAME}`,
    path: "/inventory/items",
    icon: "layout",
    component: InventoryItemListComponent,
  },
  {
    name: `Create Inventory Items - ${APP_NAME}`,
    path: "/inventory/items/create",
    component: InventoryItemsCreateComponent,
  },
  {
    name: `Edit Inventory Items- ${APP_NAME}`,
    path: "/inventory/items/edit",
    component: InventoryItemsEditComponent,
  },
  {
    name: `Upload Inventory Items- ${APP_NAME}`,
    path: "/inventory/items/upload",
    component: InventoryItemsFileUploadComponent,
  },
];

export default inventoryItemsRoutes;
